<template>
  <AdsTemplate>
    <div id="live-page" class="match-list-container">
      <Pagination
        :page="page"
        :total="matches.total"
        :per-page="perPage"
        @input="page = $event"
      ></Pagination>
      <MatchControl
        :filters="filters"
        :sorting="sorting"
        :constants="constants"
      />
      <div class="match-list">
        <component
          :is="match.mini ? 'MatchMini' : 'Match'"
          v-for="match in matches.data"
          :id="match.id"
          :key="match.id"
          :time-level="match.timeLevel"
          :league="match.league"
          :away="match.away"
          :home="match.home"
          :part="match.part"
          :time="match.time"
          :mini="match.mini"
          :is-favorite="match.isFavorite"
          :time-level-class="match.$timeLevel"
          :home-level-class="match.$homeLevel"
          :away-level-class="match.$awayLevel"
          :live-signals="$can('LIVE_SIGNAL') ? match.liveSignals : []"
          :match="match"
          :permision="user ? user.permision: ''"
          @view="toggleMatchView(match.id)"
          @favorite="setFavoriteMatch(match.id)"
        >
        </component>
        <Pagination
          :page="page"
          :total="matches.total"
          :per-page="perPage"
          @input="page = $event"
        ></Pagination>
      </div>
    </div>
    <slot />
  </AdsTemplate>
</template>

<script>
import AdsTemplate from "@/views/AdsTemplate.vue";
import Pagination from "@/components/Pagination.vue";
import Match from "@/components/LiveMatch.vue";
import MatchMini from "@/components/LiveMatchMini.vue";
import TriangleIcon from "@/components/common/icons/Triangle.vue";
import SubscribePreview from "@/components/SubscribePreview.vue";
import { MatchUtil } from "../store/utils/index.js";
import MatchControl from "../components/common/MatchControl.vue";
// import WebSocketService from "../socket";
// import io from 'socket.io-client';

const { SORT_TYPES, FETCH_STATUS, MatchList } = MatchUtil;
const { MATCH_FILTER_KEYS } = MatchList;

const filters = [
  MATCH_FILTER_KEYS.ALL,
  MATCH_FILTER_KEYS.FAVORITES,
  MATCH_FILTER_KEYS.SIGNALS,
];
const sorting = [SORT_TYPES.TIME, SORT_TYPES.STATS];

export default {
  name: "Live",
  components: {
    SubscribePreview,
    Match,
    MatchMini,
    AdsTemplate,
    Pagination,
    TriangleIcon,
    MatchControl,
  },
  data() {
    return {
      page: 1,
      perPage: 20,
      fetchTimeout: null,
      constants: { MATCH_FILTER_KEYS },
      // socket: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    filters() {
      return this.$store.getters.liveFilters(filters);
    },
    sorting() {
      return this.$store.getters.liveSorting(sorting);
    },
    matches() {
      const opts = { page: this.page, perPage: this.perPage };
      return this.$store.getters.liveMatches(opts);
    },
  },
  mounted() {
    this.$store.commit("SET_SORT", { type: SORT_TYPES.TIME, order: "DESC" });

    // this.socket = io('http://localhost:5000/', {
    //   path: '/score68',
    //   transports: ['websocket'],
    // });
    // // this.socket = io('https://test-api.score68.com/', {
    // //   path: '/score68',
    // //   transports: ['websocket'],
    // // });

    // this.socket.on('connect', () => {
    //   console.log('Connected to WebSocket server!');
    // });

    // this.socket.on('disconnect', () => {
    //   console.log('Disconnected from WebSocket server');
    // });

    // this.socket.on('message', (data) => {
    //   console.log('Received message:', data);
    // });
    // // WebSocketService.init();

    // this.state.fetchStatus = FETCH_STATUS.ACTIVE;
  },
  beforeUnmount() {
    // if (this.socket) {
    //   this.socket.disconnect();
    // }
    // WebSocketService.destroy();
    // this.state.fetchStatus = FETCH_STATUS.NON_ACTIVE;
    // this.$store.commit("updateSearchText", { value: "", category: CATEGORY });
  },
  methods: {
    toggleMatchView(id) {
      // A-9: гейтинг на контроле (<Lock> в HeaderMatch), здесь только действие
      this.$store.commit("TOGLE_LIVE_EXPANDED", id);
    },
    setFavoriteMatch(id) {
      this.$store.dispatch("toggleFavorite", id);
    },
  },
};
</script>

<style lang="scss" scoped>
#live-page {
  margin-top: 0.75rem;
}
</style>
